// TODO: use newer blocksdk once QA bugfix is available
// import SDK from 'blocksdk';
import SDK from './blocksdk';

export const sdk = new SDK({ tabs: ['htmlblock'] });

export function saveBlockData(data) {
  return new Promise((resolve, reject) => {
    try {
      sdk.setData({ blockData: data });
      resolve();
    } catch (err) {
      console.error('failed to setData', err);
      reject('Failed to setData ' + err.message);
    }
  });
}

export function saveCentralData(data) {
  return new Promise((resolve, reject) => {
    try {
      sdk.setCentralData({ ...data });
      resolve();
    } catch (err) {
      console.error('failed to setCentralData', err);
      reject('Failed to setCentral Data ' + err.message);
    }
  });
}

export function setSuperContent(content) {
  return new Promise((resolve, reject) => {
    try {
      sdk.setSuperContent(content, data => resolve(data));
    } catch (err) {
      console.error('failed to setSuperContent', err);
      reject('Failed to setSuperContent ' + err.message);
    }
  });
}

export function setContent(content) {
  return new Promise((resolve, reject) => {
    try {
      sdk.setContent(content, data => resolve(data));
    } catch (err) {
      console.error('failed to setContent', err);
      reject('Failed to setContent ' + err.message);
    }
  });
}

export function triggerAuth(appId) {
  return new Promise((resolve, reject) => {
    try {
      sdk.triggerAuth(appId);
      resolve(null);
    } catch (err) {
      console.error('failed to triggerAuth', err);
      reject('Failed to triggerAuth in blocksdk');
    }
  });
}

export function getBlockData() {
  return new Promise((resolve, reject) => {
    try {
      sdk.getData(data => {
        if (data && data.blockData) {
          resolve(data.blockData);
        } else {
          resolve(null);
        }
      });
    } catch (err) {
      console.error('failed to getData', err);
      reject('Failed to getData from blocksdk');
    }
  });
}

export function getUserData() {
  return new Promise((resolve, reject) => {
    try {
      sdk.getUserData(data => {
        if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      });
    } catch (err) {
      console.error('failed to getUserData', err);
      reject('Failed to getUserData from blocksdk');
    }
  });
}

export function getCentralData() {
  return new Promise((resolve, reject) => {
    try {
      sdk.getCentralData(data => {
        if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      });
    } catch (err) {
      console.error('failed to getCentralData', err);
      reject('Failed to getCentralData from blocksdk');
    }
  });
}

export function getView() {
  return new Promise((resolve, reject) => {
    try {
      sdk.getView(data => {
        if (data) {
          resolve(data);
        } else {
          resolve(null);
        }
      });
    } catch (err) {
      console.error('failed to getView', err);
      reject('Failed to getView from blocksdk');
    }
  });
}
